// extracted by mini-css-extract-plugin
export default {"zoomModal":"d0-z","image":"e0-z","button":"f0-z","isOverlayShown":"g0-z"};